/* eslint-disable no-shadow */
import { EMPLOYEE_PROFILE } from '../actions/employee';

const state = {
  employee: {
    isDismissed: false,
    id: -1,
    name: '',
    dismissedDate: '',
    isAdmin: false,
    role: '',
  },
};

const getters = {
  employee: (state) => state.employee,
};

const actions = {};

const mutations = {
  [EMPLOYEE_PROFILE]: (state, value) => {
    state.employee = value;
  },
};

export default () => ({
  state,
  getters,
  actions,
  mutations,
});
